import { TranslationLocale } from '../i18n';
import { I18n, I18nLocale, UiLocale } from '../models/Base';

type GetFromI18n = {
  <R>(i18nInfo: I18n<R>, locale?: I18nLocale): NonNullable<R>;
  <R>(
    i18nInfo: I18n<R> | undefined,
    locale?: I18nLocale,
  ): NonNullable<R> | undefined;
};
export const getFromI18n: GetFromI18n = (i18nInfo, locale) => {
  if (i18nInfo && locale) {
    return (
      i18nInfo.resources[locale] ?? i18nInfo.resources[i18nInfo.defaultLocale]
    );
  }
  return i18nInfo?.resources[i18nInfo?.defaultLocale];
};

type GetI18nLocale = {
  (i18nInfo: I18n<unknown>, locale?: I18nLocale): I18nLocale;
  (i18nInfo: I18n<unknown> | undefined, locale?: I18nLocale): I18nLocale;
};
export const getI18nLocale: GetI18nLocale = (i18nInfo, locale) => {
  return locale !== undefined && i18nInfo?.resources[locale] !== undefined
    ? locale
    : i18nInfo?.defaultLocale ?? locale ?? I18nLocale.US;
};

export const createI18nInfo = <R>(
  defaultLocale: I18nLocale,
  resource: R,
  resources: {
    [K in I18nLocale]?: R;
  } = {},
): I18n<R> => {
  return {
    resources: { ...resources, [defaultLocale]: resource } as {
      [K in I18nLocale]: R;
    },
    defaultLocale,
  };
};

export const uiToTranslation = (locale: UiLocale) => {
  switch (locale) {
    case UiLocale.US:
      return TranslationLocale.US;
    case UiLocale.CN:
      return TranslationLocale.CN;
    case UiLocale.HK:
      return TranslationLocale.HK;
    case UiLocale.TW:
      return TranslationLocale.TW;
    case UiLocale.JP:
      return TranslationLocale.JP;
    default:
      return locale;
  }
};

export const getUiLocale = (locale: TranslationLocale) => {
  switch (locale) {
    default:
    case TranslationLocale.EN:
    case TranslationLocale.US:
      return UiLocale.US;
    case TranslationLocale.HK:
      return UiLocale.HK;
    case TranslationLocale.ZH:
    case TranslationLocale.TW:
      return UiLocale.TW;
    case TranslationLocale.CN:
      return UiLocale.CN;
    case TranslationLocale.JA:
    case TranslationLocale.JP:
      return UiLocale.JP;
  }
};

export const getLocaleText = (locale?: UiLocale) => {
  switch (locale) {
    case UiLocale.US:
      return 'English';
    case UiLocale.CN:
      return '简体中文';
    case UiLocale.HK:
      return '繁體中文(香港)';
    case UiLocale.TW:
      return '繁體中文(台灣)';
    case UiLocale.JP:
      return '日本語';
    // case UiLocale.KR:
    //   return '한국어';
    // case UiLocale.FR:
    //   return 'Français';
    // case UiLocale.IT:
    //   return 'Italiano';
    // case UiLocale.ES:
    //   return 'Inglés';
    // case UiLocale.DE:
    //   return 'Deutsch';
    default:
      return '---';
  }
};
